<template>
    <van-popup position="bottom" v-model="isShow">
      <div class="container f28">
        <div class="title">请选择取消订单的原因（必选）</div>
        <div class="close" @click="hide"></div>
        <ul>
          <li>
            <div><radio disabled/></div>
            <span>不需要了</span>
          </li>
          <li>
            <div><radio/></div>
            <span>工期过长</span>
          </li>
          <li>
            <div><radio/></div>
            <span>价格太贵</span>
          </li>
          <li>
            <div><radio/></div>
            <span>无法修复</span>
          </li>
          <li>
            <div><radio/></div>
            <span>其他原因</span>
          </li>
        </ul>
        <button class="submit btn-black-round" disabled @click="hide">提交</button>
      </div>
    </van-popup>
</template>

<script>
  import { Popup } from 'vant'
  export default {
    name: 'cancelOrder',
    components: {
      'van-popup': Popup
    },
    data () {
      return {
        isShow: false
      }
    },
    methods: {
      show () {
        this.isShow = true
      },
      hide () {
        this.isShow = false;
        this.$emit('sumitConcel');
      }
    }
  }
</script>

<style scoped lang="scss">
  .van-popup--bottom{
    width: 101%;
  }
  .container{
    height: 740px;
    padding: 30px;
    position: relative;
    .title{
      line-height: 40px;
      margin-bottom: 50px;
    }
    ul li{
      width: 100%;
      height: 40px;
      margin-bottom: 60px;
      display: flex;
      align-items: center;
      &>div{
        margin-right: 20px;
      }
    }
    .submit{
      position: absolute;
      bottom: 30px;
      right: 30px;
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
  }
</style>
